import React from 'react';
import { Link } from 'react-router-dom';
import styles from './FooterNav.module.css';

function FooterNav({ columns, onModalOpen }) {
  if (!columns) return null;

  return (
    <nav className={styles.footerNav}>
      {columns.map((column) => (
        <div key={column.id} className={styles.column}>
          <h4 className={styles.columnTitle}>{column.title}</h4>
          <ul className={styles.columnLinks}>
            {column.links.map((link) => (
              <li key={link.id}>
                {link.modal ? (
                  <span
                    className={styles.link}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onModalOpen && onModalOpen(link.modal)}
                  >
                    {link.label}
                  </span>
                ) : (
                  <Link to={link.path} className={styles.link}>
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}

export default FooterNav;